package com.tixforgigs.common.core.util

import com.tixforgigs.apax.models.TrackEventAction
import com.tixforgigs.apax.models.TrackEventCategory
import com.tixforgigs.apax.models.TrackRequest
import io.ktor.client.request.forms.*
import io.ktor.http.*
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.properties.Properties
import kotlinx.serialization.properties.encodeToStringMap

expect object TrackerUtil {

  suspend fun pageView()
  suspend fun trackEvent(category: TrackEventCategory, action: TrackEventAction, name: String)
}

@OptIn(ExperimentalSerializationApi::class)
fun TrackRequest.toFormDataContent(): FormDataContent {
  val map = Properties.encodeToStringMap(this)
  val params = Parameters.build {
    map.forEach { (key, value) ->
      append(key, value)
    }
  }
  return FormDataContent(formData = params)
}
